import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../admin/utils/alert.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const alertService = inject(AlertService);
    const router = inject(Router);
    const isRefreshRequest = req.url.includes('/auth/refresh');

    return next(req).pipe(
        catchError((error) => {
            // IdleService handles refresh failures; do not show a competing alert or redirect first.
            if (isRefreshRequest) {
                return throwError(() => error);
            }

            console.log(error, 'errorr')
            if (error?.status == 500) {
                alertService.error(
                    `Error code: ${error?.status}`,
                    `The server encountered an unexpected problem. Please refresh the page or try again after some time.`,
                );
            } 
             else if (error?.status == 870) {
                alertService.error(
                   `Error code: ${error?.status}`,
                    `Your session token is invalid or has expired. Please log in again to continue.`,
                );
            }
             else if (error?.status == 0) {
                alertService.error(
                    `Error code: ${error?.status}`,
                    `${error?.error?.message}`,
                );
            } else if (error?.status == 400) {
                alertService.error(
                    `Error code: ${''}`,
                    `${error?.error.error}`,
                );
            } else if (error?.status == 401) {
                alertService.error(
                   `Error code: ${error?.status}`,
                    `${error?.error?.message}`,
                );
            } else if (error?.status == 405) {
                alertService.error(
                    `Error code: ${error?.status}`,
                    `Method not allowed.`,
                );
            } else if (error?.status == 403) {
                alertService.error(
                    `Error code: ${error?.status}`,
                    `${'Token Expired, Please login again'}`,
                );
                 router.navigate(['/web/home']);
            } else if (error?.status == 404) {
                alertService.error(
                    `Error code: ${error?.status}`,
                    `${error?.error?.message}`,
                );
            }

            return throwError(() => error)
        })
    );
};
